import { FaReact, FaHtml5 } from "react-icons/fa";
import invoice from "../Assets/invoice.png";
import course from "../Assets/course.png";
import femmtech from "../Assets/femmtech.png";
import nexus from "../Assets/nexus.png";
import base from "../Assets/civicccenter.png";
import port from "../Assets/techtrybe.png";
import intro from "../Assets/kennyjones.png";
import column from "../Assets/lastrucon.png";
import four from "../Assets/cowries.png";
const projects = [
  {
    id: "17",
    name: "Nexus",
    description: "Connect Patients with Doctors",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://nexus.boye-dev.com/home",
    pic: nexus,
    lang: ["React", "Material UI", "Express", "MongoDB", "TypeScript"],
    type: "web_app",
  },
  {
    id: "15",
    name: "Invoice App",
    description: "An invoicing App",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://invoicing.boye-dev.com/login",
    pic: invoice,
    lang: ["React", "Mantine UI", "Express", "MongoDB", "TypeScript"],
    type: "web_app",
  },
  {
    id: "18",
    name: "Femmtech",
    description: "Postpartum mothers hub",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://femmetech.boye-dev.com/signin",
    pic: femmtech,
    lang: ["React", "Material UI", "Express", "MongoDB", "TypeScript"],
    type: "web_app",
  },
  {
    id: "22",
    name: "Kenny Jones",
    description: "Kenny Jones website",
    icon: <FaHtml5 style={{ fontSize: "100%" }} />,
    link: "http://kennyjonesdesign.com/",
    pic: intro,
    lang: ["React", "Vite", "Mantine UI"],
    type: "website",
  },
  {
    id: "16",
    name: "Course Management System",
    description: "Manage courses for students",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://babcock-cms.vercel.app/",
    pic: course,
    lang: ["React", "Mantine UI", "Nest", "MongoDB", "TypeScript"],
    type: "web_app",
  },
  {
    id: "20",
    name: "Civic Center",
    description: "Civic Center website",
    icon: <FaHtml5 style={{ fontSize: "100%" }} />,
    link: "https://www.theciviccentre.com/",
    pic: base,
    lang: ["Next", "Tailwind", "TypeScript"],
    type: "website",
  },
  {
    id: "21",
    name: "Tech Trybe",
    description: "Tech Trybe website",
    icon: <FaHtml5 style={{ fontSize: "100%" }} />,
    link: "https://techtrybe.boye-dev.com/",
    pic: port,
    lang: ["React", "Material UI", "Firebase"],
    type: "website",
  },

  {
    id: "23",
    name: "La Strucon",
    description: "La Strucon website",
    icon: <FaHtml5 style={{ fontSize: "100%" }} />,
    link: "https://www.lastrucon.com/",
    pic: column,
    lang: ["Next", "Tailwind", "TypeScript"],
    type: "website",
  },
  {
    id: "24",
    name: "Cowries Ventures",
    description: "Cowries Ventures website",
    icon: <FaHtml5 style={{ fontSize: "100%" }} />,
    link: "https://www.cowriesventuresltd.com/",
    pic: four,
    lang: ["Next", "Tailwind", "TypeScript"],
    type: "website",
  },
];

export default projects;
